$(document).ready(function() {
    var email_form = $('form#org_landing_page');
    var email_error = $('#email_submit_error');
    var access_code_error = $('#access_code_submit_error');
    var email_already_exists_error = $('#email_already_exists_error');
    var email_invalid_error = $('#email_invalid_error');
    const eligibility_consumed_error = $('#eligibility_consumed_error');
    var success = $('#email_submit_success');
    var submit = $('form#org_landing_page').find('#submit_email');

    const handleIsInstitutionEmail = () => {
        let form = $('#org_landing_page');
        let url = form.attr('action');
        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(),
            complete: function(data){
                if (!data.responseJSON.redirect_url) {
                    $('body').css('cursor', 'default');
                    submit.attr('disabled', false);
                    submit.removeClass('loading');
                }
            },
            success: function(data) {
                if (!!data.status && data.status === 'success') {
                    if (data.redirect_url) {
                       window.location.href = data.redirect_url;
                    } else {
                        email_form.hide();
                        let email = form.find("input[name='email']").val();
                        success.find('#submitted_email').text(email);
                        success.show();
                    }
                } else {
                    email_error.show();
                }
            },
            error: function (data) {
                if (!!data.responseJSON && !!data.responseJSON.errors.eligibility_consumed) {
                    eligibility_consumed_error.show();
                } else if (!!data.responseJSON && !!data.responseJSON.errors.email) {
                    email_invalid_error.show();
                } else {
                    email_error.show();
                }
            }
        });
    }

    const handleIsEmail = () => {
        var form = $('#org_landing_page');
        var url = form.attr('action');
        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(),
            complete: function(){
                $('body').css('cursor', 'default');
                submit.attr('disabled', false);
                submit.removeClass('loading');
            },
            success: function(data) {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    email_error.show();
                    return;
                }
                if(!!data.status && data.status === 'success'){
                    email_form.hide();
                    var email = form.find("input[name='email']").val();
                    success.find('#submitted_email').text(email);
                    success.show();
                } else if (data.errors?.invalid_email) {
                    email_invalid_error.show();
                } else {
                    email_error.show();
                }
            },
            error: function () {
                email_error.show();
            }
        });
    }

    const handleIsAccessCode = () => {
        var form = $('#org_landing_page');
        var url = form.attr('action');
        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(),
            complete: function(){
                $('body').css('cursor', 'default');
                submit.attr('disabled', false);
                submit.removeClass('loading');
            },
            success: function(data) {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    email_error.show();
                    return;
                }
                if(!!data.status && data.status === 'success'){
                    email_form.hide();
                    var email = form.find("input[name='email']").val();
                    success.find('#submitted_email').text(email);
                    success.show();
                } else if (data.errors?.invalid_access_code) {
                    access_code_error.show();
                } else if (data.errors?.email_already_exists) {
                    email_already_exists_error.show();
                } else if (data.errors?.invalid_email) {
                    email_invalid_error.show();
                } else {
                    email_error.show();
                }
            },
            error: function (e) {
                email_error.show();
            }
        });
    }

    email_form.on('submit', function(e) {
        submit.attr('disabled', true);
        e.preventDefault();
        success.hide();
        email_error.hide();
        access_code_error.hide();
        email_already_exists_error.hide();
        email_invalid_error.hide();
        $('body').css('cursor', 'auto');

        if (
            (
                page_info.landing_page?.is_bhorg 
                || (page_info.landing_page?.is_institution && page_info.landing_page?.dependents_allowed)
                || (
                    page_info.landing_page?.is_institution 
                    && (page_info.landing_page?.landing_page_signup_code_allowed || page_info.landing_page?.landing_page_verification_enabled)
                )
            )
            && !$('#email_for_organization').val()?.includes('@')
            && !$('#access_code_for_organization').val()
        ) {
            $('#access_code_for_organization').val($('#email_for_organization').val());
            $('#access_code_container').attr('hidden', false);
            $('#email_for_organization_label').text("Please enter your email to receive your benefit:");
            $('#email_for_organization').val('');
            $('form#org_landing_page').find('#submit_email').attr('disabled', false);
            $('body').css('cursor', 'default');
            return;
        }

        if (
            page_info.landing_page?.is_bhorg
            && (!$('#email_for_organization').val().includes('@') || $('#access_code_for_organization').val())
            && !page_info.landing_page.is_institution
        ) {
            handleIsAccessCode();
        } else if (page_info.landing_page.is_institution) {
            handleIsInstitutionEmail();
        } else {
            handleIsEmail();
        }
    });
    $('form#org_landing_page').find('#submit_email').attr('disabled', false);
});
